import featureVideoConfig from './feature/video'

// Keeping this for future troubleshooting.
const brightcoveConfig = featureVideoConfig.brightcove

const translateVideoConfig = featureVideoConfig.translate

const SUPPRESSED_PLAYER_ERRORS = featureVideoConfig.suppressedPlayerErrors

export { brightcoveConfig, translateVideoConfig, SUPPRESSED_PLAYER_ERRORS }
